module.exports = __webpack_public_path__ + "img/help5.a63a6fd4.png";